import * as React from "react";
import type { SVGProps } from "react";
const SvgTicketFlight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#000" clipPath="url(#ticket-flight_svg__a)">
      <path d="M21 21H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2 1 1 0 0 1-1-1V6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1v4a3 3 0 0 1-3 3M2 14.83V18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3.17a3 3 0 0 1-1.45-4.563A3 3 0 0 1 22 9.17V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.17a3 3 0 0 1 1.45 4.563A3 3 0 0 1 2 14.83" />
      <path d="M16 7a1.2 1.2 0 0 1 1.65.23 1.11 1.11 0 0 1-.2 1.61l-2.21 1.64a.83.83 0 0 0-.32.58l-.45 5.49a.87.87 0 0 1-1.73 0l-.58-3.79-1.6 1.19a.33.33 0 0 0-.13.3l.18 1.9a.65.65 0 0 1-1.18.43l-3.25-4.12a.64.64 0 0 1 .74-1l1.84.67a.35.35 0 0 0 .33 0l1.61-1.18-3.63-1.54a.84.84 0 0 1 .47-1.61l5.59 1a.9.9 0 0 0 .66-.15z" />
    </g>
    <defs>
      <clipPath id="ticket-flight_svg__a">
        <path fill="#fff" d="M0 3h24v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTicketFlight;
